<template>
  <div>
    <div class="flex flex-wrap gap-4">
      <div class="w-full xl:w-1/4">
        <search-year
          label="평가연도"
          v-model="nav.year"
          :options="{
            default: new Date().getFullYear(),
            gridTemplateColumns: '80px 178px',
            xlWidthFull: true,
          }"
        />
      </div>
      <div class="w-full xl:w-1/3">
        <search-start-end
          label="평가일"
          v-model="nav.date"
          :options="{
            default: { sd: '', ed: '' },
            gridTemplateColumns: '114px 1fr',
          }"
        />
      </div>
      <div class="w-full xl:w-1/4">
        <search-check-group
          label="중요위험"
          v-model="nav.importantRisk"
          :options="{
            list: [
              { text: 'Y', value: 'Y' },
              { text: 'N', value: 'N' },
            ],
            selectMaxCount: 2,
            default: [],
            gridTemplateColumns: '114px 178px',
          }"
        />
      </div>
      <div class="w-full xl:w-1/4">
        <search-select-field
          v-if="false"
          label="사업장"
          v-model="nav.field"
          :options="{
            default: { fieldId: '', fieldName: '' },
            gridTemplateColumns: '80px 1fr',
          }"
        />
        <search-label-body label="사업장" :columns="'80px 149px'">
          <vs-select class="w-full" autocomplete v-model="nav.사업장">
            <vs-select-item v-for="(option, index) in options.사업장" :key="index" :text="option" :value="option" />
          </vs-select>
        </search-label-body>
      </div>
      <div class="w-full xl:w-1/3">
        <search-start-end
          label="결재완료일"
          v-model="nav.approvalDate"
          :options="{
            default: { sd: '', ed: '' },
            gridTemplateColumns: '114px 1fr',
          }"
        />
      </div>
      <div class="w-full xl:w-1/3">
        <search-column-keyword
          label="검색조건"
          v-model="nav.column"
          @handleClickSearch="$emit('search')"
          :options="{
            addList: ['문서번호'],
            // 팀(업체)명/공장명/대·중분류는 아래 계단식 선택(736/895 기준)으로만 찾도록 키워드 검색에서는 감춘다.
            // 소분류는 키워드로도 찾을 수 있게 노출한다. (Page.vue 에서 raw 스냅샷이 아니라 736/895 최신값에 LIKE → raw.id 매칭)
            // 팀(업체)명/공장명/대·중분류도 Page.vue(CLASSIFICATION_KEYWORD_FIELD)가 같은 방식으로 처리하므로,
            // 키워드 검색에 추가하고 싶으면 이 목록에서 이름만 빼면 된다.
            hiddenList: ['사업장명', '구분1', '중요위험', '평가일', '결재완료일', '구분2', '구분3', '팀(업체)명', '공장명', '대분류', '중분류'],
            gridTemplateColumns: '114px 1fr',
          }"
        />
      </div>
      <div class="w-full xl:w-1/4">
        <search-label-body label="구분2" :columns="'80px 149px'">
          <vs-select class="w-full" v-model="nav.구분2">
            <vs-select-item value="전체" text="전체" />
            <vs-select-item value="정기" text="정기" />
            <vs-select-item value="수시" text="수시" />
          </vs-select>
        </search-label-body>
      </div>
      <div class="w-full xl:w-1/4">
        <search-label-body label="구분3" :columns="'114px 149px'">
          <vs-select class="w-full" v-model="nav.구분3">
            <vs-select-item value="전체" text="전체" />
            <vs-select-item value="JSA" text="JSA" />
            <vs-select-item value="DKRAS" text="DKRAS" />
            <vs-select-item value="DKRAS+JSA" text="DKRAS+JSA" />
          </vs-select>
        </search-label-body>
      </div>

      <div class="flex w-full items-end flex-wrap gap-4">
        <div class="w-full xl:w-1/6">
          <search-label-body label="팀(업체)명" :columns="'80px 1fr'">
            <vs-select class="w-full" autocomplete v-model="nav.팀업체명">
              <vs-select-item v-for="(option, index) in options.팀명" :key="index" :text="option" :value="option" />
            </vs-select>
          </search-label-body>
        </div>
        <div class="w-full xl:w-1/6">
          <search-label-body label="공장명" :columns="'80px 1fr'">
            <vs-select class="w-full" autocomplete v-model="nav.공장명" :disabled="nav.팀업체명 === '전체'">
              <vs-select-item v-for="(option, index) in options.공장명" :key="index" :text="option" :value="option" />
            </vs-select>
          </search-label-body>
        </div>
        <div class="w-full xl:w-1/6">
          <search-label-body label="대분류" :columns="'80px 1fr'">
            <vs-select class="w-full" autocomplete v-model="nav.대분류" :disabled="nav.팀업체명 === '전체' || nav.공장명 === '전체'">
              <vs-select-item v-for="(option, index) in options.대분류" :key="index" :text="option" :value="option" />
            </vs-select>
          </search-label-body>
        </div>
        <div class="w-full xl:w-1/6">
          <search-label-body label="중분류" :columns="'80px 1fr'">
            <vs-select class="w-full" autocomplete v-model="nav.중분류" :disabled="nav.팀업체명 === '전체' || nav.공장명 === '전체' || nav.대분류 === '전체'">
              <vs-select-item v-for="(option, index) in options.중분류" :key="index" :text="option" :value="option" />
            </vs-select>
          </search-label-body>
        </div>
        <!-- 소분류는 상위 단계를 고르지 않아도 바로 고를 수 있도록 비활성화하지 않는다.
             (키워드 검색에서 소분류를 감춘 뒤, 소분류만으로 찾던 기존 사용방식이 막혔던 문제) -->
        <div class="w-full xl:w-1/6">
          <search-label-body label="소분류" :columns="'80px 1fr'">
            <vs-select class="w-full" autocomplete v-model="nav.소분류">
              <vs-select-item v-for="(option, index) in options.소분류" :key="index" :text="option" :value="option" />
            </vs-select>
          </search-label-body>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchYear from "@/views/list/components/SearchYear.vue";
import SearchStartEnd from "@/views/list/components/SearchStartEnd.vue";
import SearchCheckGroup from "@/views/list/components/SearchCheckGroup.vue";
import SearchSelectField from "@/views/list/components/SearchSelectField.vue";
import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";

export default {
  components: {
    SearchYear,
    SearchStartEnd,
    SearchCheckGroup,
    SearchSelectField,
    SearchColumnKeyword,
    SearchLabelBody,
  },
  props: {
    value: Object,
    options: Object,
  },
  computed: {
    nav: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      },
    },
  },
  created() {
    console.log("options", this.options);
  },
};
</script>
